<script>
export default {
    methods: {
        getCashoutStatusName(status) {
            switch (status) {
                case "approved":
                    return "Efetuado";
                case "sent_to_bank":
                    return "Enviado ao Banco";
                case "returned":
                    return "Retornado";
                case "building":
                    return "Em Construção";
                case "in_audit":
                    return "Em Auditoria";
                case "requested":
                    return "Solicitado";
                case "extrajudicial_compensation":
                    return "Compensação Por Acordo Extrajudicial";
                case "chargeback_penalty":
                    return "Multa por Excesso de Chargeback";
                default:
                    return status;
            }
        },
        getCashoutAccountType(type) {
            switch (type) {
                case "checking":
                    return "Conta Corrente";
                case "saving":
                    return "Conta Poupança";
                default:
                    return type;
            }
        },
        getCashoutStatusClass(status) {
            switch (status) {
                case "approved":
                    return "chip-emerald";
                case "returned":
                    return "chip-rose";
                case "building":
                    return "chip-amber";
                case "in_audit":
                    return "chip-violet";
                case "requested":
                    return "chip-slate";
                case "sent_to_bank":
                    return "chip-amber";
                case "extrajudicial_compensation":
                    return "chip-orange";
                case "chargeback_penalty":
                    return "chip-rose";
                default:
                    return "chip-sky";
            }
        },

        formatBankCode(code = "") {
            return code.padStart(3, 0);
        },
    },
};
</script>
